export default {
  home: 'الصفحة الرئيسية',
  aboutUs: 'معلومات عنا',
  productsAndServices: 'المنتجات والخدمات',
  projectCases: 'حالات المشروع',
  contactUs: '📩 اتصل بنا',
  contactUs2: 'اتصل بنا',
  scrollDown: 'مرر لأسفل',
  companyName: 'شركة التناغم المحيطي التجاريةشركة التناغم المحيطي التجارية',
  companyIntro: 'مقدمة الشركة',
  brandStory: 'قصة العلامة التجارية',
  developmentHistory: 'التطور التاريخي',
  corporateCulture: 'ثقافة الشركة',
  qualificationsAndHonors: 'الشهادات والتكريمات',
  partners: 'شركاؤنا',
  customer: 'العميل',
  domesticNetwork: 'الشبكة المحلية',
  overseasNetwork: 'الشبكة الخارجية',
  businessOutlets: 'نقاط العمل',
  fullCategoryTransportService: 'خدمة النقل لجميع الفئات',
  oneStopSupplyChainService: 'خدمة سلسلة التوريد "الشاملة"',
  mainEngineeringMaterialsProducts: 'منتجات مواد الهندسة الرئيسية',
  logisticsBusiness: 'أعمال الخدمات اللوجستية',
  materialsBusiness: 'أعمال المواد',
  fullSupplyChainBusiness: 'أعمال سلسلة التوريد الكاملة',
  aboutOceanHarmony: 'تعرف على Ocean Harmony',
  historyAndEvolution: 'التطور التاريخي (2024 ~ حتى الآن)',
  companyHonors: 'تكريمات الشركة',
  address: 'العنوان',
  phone: 'الهاتف',
  email: 'البريد الإلكتروني',
  send: 'إرسال',
  weChatQRCode: 'رمز WeChat QR',
  scanToFollowUs: 'امسح للتواصل معنا',
  contact: 'ارسل استفسارك في أي وقت!',
  mondayToFriday: 'من الأحد إلى الخميس',
  leaveMessage: 'محتوى الرسالة',
  subject: 'اسم الشركة',
  nickname: 'كيف نخاطبك',
  cooperationIntent: 'نية التعاون',
  companyTopName: "Zhongcheng Group",
  transportation: "Zhongcheng Transport",
  copyright: "جميع الحقوق محفوظة",
  companyTopTitle: "ZCTS SHENZHEN CO., LTD.",
  projectDetail: 'تفاصيل المشروع',

  // 表单验证消息
  enterYourName: 'مثال: المدير وانغ / السيد تشانغ',
  nameRequired: 'يرجى إدخال كيفية مخاطبتك',
  enterYourEmail: 'اختياري، لتسهيل إرسال عرض الأسعار',
  enterYourPhone: 'يرجى إدخال رقم جوالك أو رقم الجوال المرتبط بويتشات ليتواصل معك المختص بسرعة',
  phoneRequired: 'يرجى إدخال رقم الجوال',
  invalidPhone: 'يرجى إدخال رقم جوال صحيح',
  enterSubject: 'يرجى إدخال الاسم الكامل أو المختصر للشركة (للأعمال الشخصية اكتب "فرد")',
  companyRequired: 'يرجى إدخال اسم الشركة',
  selectIntent: 'يرجى اختيار الخدمة التي تحتاجها',
  intentLogistics: 'لدي بضائع تحتاج نقل / تخليص جمركي / تخزين (خدمة لوجستية)',
  intentTrade: 'أريد شراء سلع أو أحتاج وكالة استيراد وتصدير (تجارة وسلسلة توريد)',
  intentSupplier: 'أنا مصنع أو مزود خدمة وأرغب في توفير بضائع أو طاقة نقل (تعاون موردين)',
  intentOther: 'استشارة تجارية أخرى (لم أحدد النشاط بعد)',
  leaveHintDefault: 'يرجى اختيار نية التعاون أولاً',
  leaveHintLogistics: 'يرجى وصف اسم البضاعة ومكان الانطلاق والوجهة والوزن أو الحجم التقريبي.',
  leaveHintTrade: 'يرجى وصف المنتجات المطلوبة أو حالة البضاعة والمنطقة المستهدفة إذا كنتم تحتاجون استيراد/تصدير أو استرداد ضريبي أو تمويل.',
  leaveHintSupplier: 'يرجى وصف منتجاتكم الرئيسية أو خطوط النقل المميزة وفكرة التعاون، وسنحولها للقسم المختص.',
  leaveHintOther: 'يرجى وصف خلفية أعمالكم وطلب التعاون، وسيقوم المختص بترتيب القسم المناسب.',
  enterMessageContent: 'يرجى إدخال محتوى الرسالة',
  enterValidEmail: 'الرجاء إدخال عنوان بريد إلكتروني صالح',
  messageContentAtLeast10: 'يجب أن يكون محتوى الرسالة 10 أحرف على الأقل',
  nameLengthBetween2And30: 'يجب أن يكون طول المخاطبة بين 2 و 30 حرفًا',
  formSubmitSuccess: 'تم الإرسال بنجاح! شكراً لتواصلك معنا.',
  completeFormBeforeSubmitting: 'الرجاء استكمال معلومات النموذج قبل الإرسال',
  submitFailed: 'فشل الإرسال، يرجى المحاولة لاحقاً',
  slideVerifyLabel: 'التحقق الأمني',
  verifyDialogTitle: 'التحقق الأمني',
  verifyDialogDesc: 'يرجى سحب الشريط إلى أقصى اليمين لتأكيد أنك لست روبوتاً.',
  cancel: 'إلغاء',
  slideVerifyText: 'اسحب الشريط إلى اليمين',
  verificationSuccess: 'تم التحقق',
  completeSlideVerifyFirst: 'يرجى إكمال التحقق بالسحب أولاً',
  subjectLengthLimit: 'يجب أن يكون اسم الشركة بين 2 و 100 حرف',
  messageContentLengthLimit: 'يجب أن يكون طول الرسالة بين 10 و 500 حرف',

  // 其他内容
  mainTilte: 'متخصصون في مجال مشاريع الهندسة، نقدم منتجات المواد الرئيسية التالية وفقًا لخصائص المشاريع الهندسية',
  ViewDetails: 'عرض التفاصيل',
  Loading: 'جار التحميل...',
  companyCoverage: "تغطي <span class=\"map-top\">&nbsp;13&nbsp;</span> شركة محلية المدن الساحلية الرئيسية على طول الطريق",
  businessOutletsTitle1: "أوشن هارموني لديها حالياً <span class='w-map-top'>&nbsp; 9 &nbsp;</span> نقاط عمل مباشرة في الخارج",
  businessOutletsTitle2: "أكثر من <span class='w-map-top'>&nbsp; 14 &nbsp;</span> عاماً من التواجد العميق في أفريقيا وجنوب شرق آسيا",
  qayimatAlmuntajat: "قائمة المنتجات",
  LanguageMessage: "تم تغيير اللغة بنجاح!",
    WHATSAPP:'واتساب'
};